import { isTokenExpired } from "../../../utils/helpers";

export class TokenValidationCommand {
  constructor(token) {
    this.token = token;
  }

  execute() {
    return !isTokenExpired(this.token);
  }
}